import { render, staticRenderFns } from "./ChartTab.vue?vue&type=template&id=64e66996&scoped=true&"
import script from "./ChartTab.vue?vue&type=script&lang=js&"
export * from "./ChartTab.vue?vue&type=script&lang=js&"
import style0 from "./ChartTab.vue?vue&type=style&index=0&id=64e66996&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e66996",
  null
  
)

export default component.exports